/* eslint-disable
    eqeqeq,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import _ from 'underscore';

import { View } from 'app/scripts/views/internal/View';

export interface CollectionView {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  listenPropagators: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  sortDebounced: any;
}
export class CollectionView extends View {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(options: any) {
    super(options);
    this.sort = this.sort.bind(this);
  }

  initialize() {
    this.listenPropagators = {};

    this.makeDebouncedMethods('sort');

    this.listenTo(this.collection, {
      sort: this.sortDebounced,
      add: this.addModel,
      remove: this.removeModel,
      reset: this.reset,
    });

    return super.initialize(...arguments);
  }

  getModels() {
    return this.collection.models;
  }

  // Override the subview method to register a blanket listener that will
  // propagate all subview-triggered events to trigger on the CollectionView.
  subview() {
    // @ts-expect-error TS(2556): A spread argument must either have a tuple type or... Remove this comment to see the full error message
    const view = super.subview(...arguments);
    // @subview gets called a lot, so make sure we only register this once
    if (this.listenPropagators[view.cid] == null) {
      this.listenPropagators[view.cid] = this.listenTo(
        view,
        'all',
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (event: any, ...args: any[]) => {
          return this.trigger(event, view, ...Array.from(args));
        },
      );
    }
    return view;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  addModel(model: any, options: any) {
    // @ts-expect-error TS(2554): Expected 0 arguments, but got 2.
    const view = this.subview(this.viewType, model);
    if (this.el) {
      // @ts-expect-error TS(2554): Expected 3 arguments, but got 2.
      this.insertSubview(view, _.indexOf(this.getModels(), model));
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  removeModel(model: any, options: any) {
    return this.removeSubview(this.viewForModel(model));
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  reset(collection: any, { previousModels }: any) {
    let model;
    const keptModels = {};
    for (model of Array.from(collection.models)) {
      // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      keptModels[model.cid] = true;
    }
    for (model of Array.from(previousModels)) {
      // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      if (!keptModels[model.cid]) {
        // @ts-expect-error TS(2554): Expected 2 arguments, but got 1.
        this.removeModel(model);
      }
    }
    return this.sort();
  }

  sort() {
    const placeHolderIndices = Array.from(this.el.children)
      .map(function (el, index) {
        if (el.matches('.placeholder,.card-composer')) {
          return index;
        } else {
          return null;
        }
      })
      .filter((index) => index !== null);

    const iterable = this.getModels();
    for (let index = 0; index < iterable.length; index++) {
      const model = iterable[index];
      const effectiveIndex =
        index +
        placeHolderIndices.filter(
          // @ts-expect-error TS(2531): Object is possibly 'null'.
          (placeholderIndex) => placeholderIndex <= index,
        ).length;
      this.moveSubviewToPosition(
        // @ts-expect-error TS(2554): Expected 0 arguments, but got 2.
        this.subview(this.viewType, model),
        effectiveIndex,
      );
    }
  }

  render() {
    let model;
    // @ts-expect-error TS(2554): Expected 2 arguments, but got 1.
    this.appendSubviews(
      (() => {
        const result = [];
        for (model of Array.from(this.getModels())) {
          // @ts-expect-error TS(2554): Expected 0 arguments, but got 2.
          result.push(this.subview(this.viewType, model));
        }
        return result;
      })(),
    );
    return this;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  viewForModel(model: any) {
    // @ts-expect-error TS(2554): Expected 3 arguments, but got 2.
    return this.existingSubviewOrUndefined(this.viewType, model);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  removeSubview(subview: any) {
    return this.deleteSubview(subview);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  insertSubview(subview: any, target: any, $el: any) {
    if ($el == null) {
      ({ $el } = this);
    }
    // Turn target from an index or a view into an element
    if (typeof target === 'number') {
      if (target <= 0) {
        target = $el.children().eq(0);
      } else if (target < $el.children().length) {
        target = $el.children().eq(target);
      } else {
        target = undefined;
      }
    } else if (target instanceof View) {
      target = target.$el;
    }

    if (subview.$el.is(':empty')) {
      // If the subview's $el is empty, it hasn't been rendered, so render it
      subview.delegateEvents();
      subview.render();
    }

    if ((target != null ? target.length : undefined) > 0) {
      subview.$el.insertBefore(target);
    } else {
      $el.append(subview.$el);
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  moveSubviewToPosition(subview: any, position: any) {
    if (subview.$el.is(':empty')) {
      // If the subview hasn't been rendered, it needs to also be inserted
      this.insertSubview(subview, position, this.$el);
      return;
    }

    const { children } = this.el;

    const currentPosition = subview.$el.index();
    if (currentPosition === position) {
      return;
    }

    if (position === 0) {
      this.$el.prepend(subview.$el);
    } else if (position >= children.length) {
      this.$el.append(subview.$el);
    } else {
      subview.$el.insertAfter(children[position - 1]);
    }
  }
}
